import React, { useState, useEffect } from 'react';
import './Stars.css'
import Stars100 from '../media/imagen/Stars100.svg'
import StatusPieChart from './StatusPieChart';

const STATUS_KEYS = {
  STARS: 'Социометрические звезды',
  HIGH: 'Высокий статус',
  MID: 'Средний статус',
  LOW: 'Низкий статус',
  ISOLATED: 'Изолированные',
  REJECTED: 'Отверженные',
  NEGLECTED: 'Пренебрегаемые или изгои',
  NONE: 'Никто'
};

const Stars = ({ testID }) => {
    const [statusData, setStatusData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStatusData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) throw new Error('Токен авторизации не найден');

                const response = await fetch(
                    `http://185.250.149.189:8000/api/v1/Results/Sociometric/Stars?test_id=${testID}`,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': `Token ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
                const result = await response.json();
                setStatusData(result);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchStatusData();
    }, [testID]);

    // Обработка состояний загрузки и ошибок
    if (loading) {
        return <div className='Stars-container'>Загрузка данных...</div>;
    }

    if (error) {
        return <div className='Stars-container'>Ошибка: {error}</div>;
    }

    if (!statusData || !statusData.results) {
        return <div className='Stars-container'>Данные не получены</div>;
    }

    // Подготовка данных для диаграммы
    const chartData = Object.entries(statusData.results).map(([key, value]) => ({
        name: key,
        value: value
    }));

    return (
        <div className='Stars-container'>
            <div> 
                <h2>О группе</h2>
                <span className='Stars-group'>Тут будет текст о группе, настраиваемый</span> 
            </div>
            <h2>Индивидуальные статусы участников</h2>
            <StatusPieChart data={chartData} />
            <div className='Stars-card-container'>
                {/* Карточка 1: Социометрические звезды */}
                <div className='Stars-card'>
                    <img 
                        src={Stars100} 
                        alt="Социометрические звезды" 
                        className="stars-group-icon"
                    />
                    <h3>Социометрические <br /> звезды</h3>
                    <div>
                        <span className='BigNum'>{statusData.results[STATUS_KEYS.STARS]}</span>
                        <span className='Stars-group'>человек</span>
                    </div>
                    <span className='Stars-text-card'>
                        Максимальное количество положительных выборов при небольшом количестве отрицательных выборов. 
                        Это люди, к которым обращены симпатии большинства или, по крайней мере, многих членов группы.
                    </span>
                </div> 
                
                {/* Карточка 2: Высокостатусные */}
                <div className='Stars-card'>
                    <img 
                        src={Stars100} 
                        alt="Высокостатусные члены группы" 
                        className="stars-group-icon"
                    />
                    <h3>Высокостатусные <br /> члены группы</h3>
                    <div>
                        <span className='BigNum'>{statusData.results[STATUS_KEYS.HIGH]}</span>
                        <span className='Stars-group'>человек</span>
                    </div>
                    <span className='Stars-text-card'>
                        Большое количество положительных выборов и немного отрицательных выборов. 
                        Это люди, которые положительно воспринимаются группой и принимаются большей ее частью.
                    </span>
                </div> 
                
                {/* Карточка 3: Среднестатусные */}
                <div className='Stars-card'>
                    <img 
                        src={Stars100} 
                        alt="Среднестатусные члены группы" 
                        className="stars-group-icon"
                    />
                    <h3>Среднестатусные <br /> члены группы</h3>
                    <div>
                        <span className='BigNum'>{statusData.results[STATUS_KEYS.MID]}</span>
                        <span className='Stars-group'>человек</span>
                    </div>
                    <span className='Stars-text-card'>
                        Достаточное количество положительных выборов при наличии значительного количества отрицательных выборов
                    </span>
                </div> 
                
                {/* Карточка 4: Низкостатусные */}
                <div className='Stars-card'>
                    <img 
                        src={Stars100} 
                        alt="Низкостатусные члены группы" 
                        className="stars-group-icon"
                    />
                    <h3>Низкостатусные<br />члены группы</h3>
                    <div>
                        <span className='BigNum'>{statusData.results[STATUS_KEYS.LOW]}</span>
                        <span className='Stars-group'>человек</span>
                    </div>
                    <span className='Stars-text-card'>
                        Равное количество положительных и отрицательных выборов. 
                        Либо часть группы (часто другая микрогруппа) эмоционально не принимает его, либо характер и цель его взаимодействий не полностью совпадают с групповыми.
                    </span>
                </div> 
                
                {/* Карточка 5: Изолированные */}
                <div className='Stars-card'>
                    <img 
                        src={Stars100} 
                        alt="Изолированные члены группы" 
                        className="stars-group-icon"
                    />
                    <h3>Изолированные <br />члены группы</h3>
                    <div>
                        <span className='BigNum'>{statusData.results[STATUS_KEYS.ISOLATED]}</span>
                        <span className='Stars-group'>человек</span>
                    </div>
                    <span className='Stars-text-card'>
                        Субъекты, у которых отсутствуют любые выборы, как положительные, так и отрицательные. 
                        Позиция изолированного человека в группе — одна из наиболее неблагоприятных.
                    </span>
                </div> 
                
                {/* Карточка 6: Отверженные */}
                <div className='Stars-card'>
                    <img 
                        src={Stars100} 
                        alt="Отверженные члены группы" 
                        className="stars-group-icon"
                    />
                    <h3>Отверженные <br />члены группы</h3>
                    <div>
                        <span className='BigNum'>{statusData.results[STATUS_KEYS.REJECTED]}</span>
                        <span className='Stars-group'>человек</span>
                    </div>
                    <span className='Stars-text-card'>
                       Имеют большое количество отрицательных выборов и малое количество предпочтений. 
                       Принимаются лишь небольшой частью, часто только своей микрогруппой и имеют мало взаимодействия и взаимосвязей.
                    </span>
                </div> 
                
                {/* Карточка 7: Пренебрегаемые или изгои */}
                <div className='Stars-card'>
                    <img 
                        src={Stars100} 
                        alt="Пренебрегаемые или изгои" 
                        className="stars-group-icon"
                    />
                    <h3>Пренебрегаемые или <br />изгои</h3>
                    <div>
                        <span className='BigNum'>{statusData.results[STATUS_KEYS.NEGLECTED]}</span>
                        <span className='Stars-group'>человек</span>
                    </div>
                    <span className='Stars-text-card'>
                       Члены группы, не имеющие ни одного положительного выбора при наличии отрицательных.
                    </span>
                </div> 
                
                {/* Карточка 8: Никто */}
                <div className='Stars-card'>
                    <img 
                        src={Stars100} 
                        alt="Никто" 
                        className="stars-group-icon"
                    />
                    <h3>Никто</h3>
                    <div>
                        <span className='BigNum'>{statusData.results[STATUS_KEYS.NONE]}</span>
                        <span className='Stars-group'>человек</span>
                    </div>
                    <span className='Stars-text-card'>
                       Описание хороших мальчиков
                    </span>
                </div> 
            </div>
        </div>
    );
};

export default Stars;